import { forEach } from "angular";
import angularDragDrop from "angular-drag-drop";
import { getDistanceSq, offset } from "@gtmhub/shared/decorators/utils/angular-dnd.util";

const mod = angular.module("ghАngularDragDrop", [angularDragDrop]);
mod.config([
  "$provide",
  function ($provide) {
    $provide.decorator("dropContainerDirective", [
      "$delegate",
      "$parse",
      "dragContext",
      "$document",
      // eslint-disable-next-line sonarjs/cognitive-complexity
      ($delegate, $parse, dragContext, $document) => {
        const directive = $delegate[0];
        // store the original link fn
        const originalLinkFn = $delegate[0].link;

        directive.compile = function () {
          return function ($scope, $element, $attrs, dropContainer) {
            // eslint-disable-next-line prefer-rest-params
            originalLinkFn.apply($delegate[0], arguments);
            const acceptsFn = $attrs.dropAccepts
              ? $parse($attrs.dropAccepts)
              : function ($scope, locals) {
                  return typeof locals.$dragData !== "undefined";
                };
            const onDragOver = $attrs.onDragOver ? $parse($attrs.onDragOver) : null;

            function handleDragOver(e) {
              const locals = {
                $event: e,
                $dragData: dragContext.data,
              };

              if (acceptsFn($scope, locals)) {
                e.preventDefault();
                const pos = offset($element, $document);

                $attrs.$addClass("drag-over");

                let minDistanceSq = Number.MAX_VALUE;
                let closestTarget = dropContainer.lastTarget;

                forEach(dropContainer.targets, function (dropTarget, anchor: unknown) {
                  const distanceSq = getDistanceSq(anchor, pos, e);
                  if (distanceSq < minDistanceSq) {
                    closestTarget = dropTarget;
                    minDistanceSq = distanceSq;
                  }
                });

                $scope.$evalAsync(function () {
                  if (onDragOver) {
                    onDragOver($scope, locals);
                  }

                  if (!closestTarget) return;

                  if (closestTarget !== dropContainer.lastTarget) {
                    if (dropContainer.lastTarget) {
                      $attrs.$removeClass("drop-container-" + dropContainer.lastTarget.anchor);
                    }

                    $attrs.$addClass("drop-container-" + closestTarget.anchor);

                    if (dropContainer.lastTarget) {
                      dropContainer.lastTarget.handleDragLeave(e, locals);
                    }

                    closestTarget.handleDragEnter(e, locals);

                    dropContainer.lastTarget = closestTarget;
                  }

                  closestTarget.handleDragOver(e);
                });
              }
            }

            $element.on("dragover", handleDragOver);
          };
        };

        // get rid of the old link function since we return a link function in compile
        delete $delegate[0].link;

        return $delegate;
      },
    ]);
  },
]);

export default mod.name;
